import Logger from '../Logger';
import PconLanguageResolver from './PconLanguageResolver';

class PconUrlBuilder {
  public static build(link: string, languageCode: string): string {
    if (!link) {
      return '';
    }

    try {
      const url = new URL(link);
      // pCon reads its parameters from the hash, not from the query string
      const params = new URLSearchParams(url.hash.substring(1));
      params.set('lang', PconLanguageResolver.resolve(languageCode));
      url.hash = params.toString();

      return url.toString();
    } catch {
      Logger.warn(`Invalid pCon link ${link} was left unchanged.`);
    }

    return link;
  }
}

export default PconUrlBuilder;
